import { useEffect, useRef, useState } from "react";
import * as images from "../../Utilities/Images";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { getSelectedEventBadge } from "../../_store/_reducers/eventList";
import { useSelector } from "react-redux";
import { parseJson } from "../../_helper";
import Loader from "../../Loader/Loader";
import { getSelectedEventDetails } from "../../_store/_reducers/user";
import { getSelectedDefaultPrinter } from "../../_store/_reducers/printer";
import { defaultBadgeDetails, handlePrint, printBadgeDetails, processAlertDetails } from "../../_services/printBadge.service";
import { getConnectionId, getUserEmail } from "../../_store/_reducers/auth";
import { userService } from "../../_services";
import AudioAlert from "../camera/AudioAkert";
import { initializeFontsComplete } from "../../_helper/imageConverter";
import DashboardHeader from "../../components/DashboardHeader";

const GuestBadge = () => {
  const eventBadgeSelector = useSelector(getSelectedEventBadge);
  const eventDetail = useSelector(getSelectedEventDetails);
  const [element, setelement] = useState(null);
  const defaultPrinter = useSelector(getSelectedDefaultPrinter);
  const userEmail = useSelector(getUserEmail);
  const [eventPreFilledData, seteventPreFilledData] = useState({});
  const [eventDataDetail, seteventDataDetail] = useState(null)
  const connection_id= useSelector(getConnectionId)??7;
  
  
  const [Loading, setLoading] = useState(false);
  const [fields, setfields] = useState([]);
  const [collapseNav, setCollapseNav] = useState(false);

  useEffect(()=>{
   initialValues()
  },[eventBadgeSelector]);
  


  const [isLoading, setisLoading] = useState(false);
  const [isLoading2, setisLoading2] = useState(false);
  

 

  const Navigate = useNavigate();

  const handleCollapse = () => {
    setCollapseNav((prev) => !prev);
  }

  const handleCLick = () => {
    if(isLoading||isLoading2)return;
    Navigate("/dashboard/cam");
  };

  const handleKioskModeClick = () => Navigate("/dashboard/kiosk-mode");
  const handleGuestClick = () => Navigate("/dashboard/guest-badge");
  const handleBadgeDesignClick = () => Navigate("/dashboard/badge-design");
  const handleCameraClick = () => Navigate("/dashboard/cam");

  const handleBadgePrint=async(value)=>{
     try {
     if(value==1) setisLoading(true)
     if(value==2)setisLoading2(true);
    let height=609;
    const fieldObj={};
    fields?.map((field)=>{
      fieldObj[field.key]=field.content;
    });
    //filter pages
    let page1=[];
    let page2=[];
    let hasError=false;
    let data=eventBadgeSelector?.data?? defaultBadgeDetails();
    let selectedFields=parseJson(data?.selectedFields);
    let canvasSize = parseJson(data?.canvas_size);
    canvasSize={
      ...canvasSize,
          height:(canvasSize.height>height?height:canvasSize.height)*2,
          width:canvasSize.width*2,
    }
    height*=2;
    let alertInfo=selectedFields?.alertInfo??{};
    element?.map((el)=>{
      el.x*=2;
      el.y*=2;
      el.height*=2;
      el.width*=2;
      el.fontSize*=2;
      const content=fieldObj[el.key]??el.content;
      if(el?.y>height){
        if(content&&content!=''&&el.key!='qr'){
          page2.push({
            ...el,
            y:Math.max(10,el.y-height),
            content
          })
        }
      }else{
        if(content&&content!=''&&el.key!='qr'){
          page1.push({
            ...el,content
          })
        }
      }
      if(alertInfo?.[el.key]&&!hasError){
                    let error=  processAlertDetails(content,{...alertInfo[el.key],alertColor:alertInfo?.alertColor});
      if(error&&!hasError){
        handleAudioPlay()
        hasError=error
      }
      }
    });
    if(!hasError){
      page1=page1.filter(e=>e.type!='icon');
      page2=page2.filter(e=>e.type!='icon');
    }
    console.log(page1,"page1")
    
    let badgeLog={
        first_name:"Guest",
        last_name:"Badge",
        email:userEmail,
        event_id:eventDataDetail?.eventId,
        badge_design_id:data?.id,
      }
     
    let data1=await printBadgeDetails(page1,page1.length,eventPreFilledData,canvasSize,defaultPrinter,alertInfo,  );
    let data2=await printBadgeDetails(page2,page2.length,eventPreFilledData,canvasSize,defaultPrinter,alertInfo);
    if(data1){
      const {dataUrl,...rest}=data1;
      let badgeDoc={
        ...rest,
        ...badgeLog,
        data_url1:dataUrl,
        data_url2:data2?.dataUrl,
        connection_id
      }
      await userService.createBadgePrintLog(badgeDoc);
      toast.success("Badge printed");
    }
    if(value==1){
      handleCLick();
    }else{
     initialValues();
    }
     
    } catch (error) {
      toast.error("Unable to download badge");
    }finally{
      setisLoading(false)
      setisLoading2(false)
    }
  }
  const handleChange=(e,index)=>{
    const value=e.target.value;
    const filterfield=fields;
    const updatedata=filterfield[index];
    updatedata.content=value;
    filterfield[index]=updatedata;
    const updatedData=[...filterfield];
    setfields(updatedData);
  }
  const initialValues=async()=>{
 let data=eventBadgeSelector?.data??defaultBadgeDetails();
    let eventData = eventDetail?.eventData;
    let eventObj={
      eventId: eventDetail?.eventId,
      title: eventData?.event_topic,
      company:eventData?.organization_name,
      state:eventData?.state,
      city:eventData?.city,
      country:eventData?.country,
    }
    seteventPreFilledData(eventObj);
    seteventDataDetail({
      ...eventData,
      eventId:eventDetail?.eventId
    });

    if(data){
      setLoading(true);
      let elements=parseJson(data?.elements);
      if(elements?.length==0){
        data=defaultBadgeDetails();
        elements=parseJson(data?.elements);
      }
      setelement(elements);
      let fieldList=[];
      console.log(elements,"elements")
      elements?.map((el)=>{
        let value=eventObj[el.key]??"";
        let obj={
          name:el?.content,
          key:el?.key,
          content:value,
          editable:!value
        };
        if(el.type=='text'&&el.key!='contact'&&el.key!='location'){
          fieldList.push(obj)
        }
      });
      setfields(fieldList );
      setLoading(false);
    }
  }
  const audioRef = useRef(null);
  const handleAudioPlay = () => {
      if (audioRef.current) {
         audioRef.current?.playAudio(true); 
      }
  };
   useEffect(() => {
      const loadFonts = async () => {
        await initializeFontsComplete();
      };
  
      loadFonts();
    }, []);
  return (
    <>
    
    
      <section className="guestBadgeMainSection">
        <AudioAlert ref={audioRef}/>
        <DashboardHeader
          handleButtonClick={handleCLick}
          handleCollapse={handleCollapse}
          handleKioskModeClick={handleKioskModeClick}
          handleGuestClick={handleGuestClick}
          handleRefresh={initialValues}
          handleClick={handleBadgeDesignClick}
          handleCameraClick={handleCameraClick}
          collapseNav={collapseNav}
        />
        <div className="container">
          <div className="row justify-content-center">
            {
      Loading?<>
      <Loader/>
      </>:
            <div className="col-lg-6">
              <div className="mainGuestContainer">
                <h1 className="guestBadgeMainHeading">BADGES+</h1>
                <div className="guestBadgeScreen">
                  <h2 className="badgeHeading marginBtm12">
                    Create Guest Badge
                  </h2>
                  <p className="badgeSubHeading marginBtm12">
                    Enter the guest’s information to create an on-demand badge
                  </p>
                  <p className="badgeNote marginBtm32">
                    NOTE: QR Codes for guest badges are not currently supported
                  </p>

                  <div className="login-form">
                    <div>
                      {
                        fields?.map((field,index)=>(

                      <div key={index} className="inputField marginBtm32">
                        <input
                          type="text"
                          className="form-control"
                          placeholder=""
                          required
                          name={field.key}
                          id={`field-${index}`}
                          value={field.content}
                          onChange={(e)=>handleChange(e,index)}
                        />
                        <label htmlFor={`field-${index}`} className="labelText text-capitalize">{field?.name}</label>
                      </div>
                        ))
                      }

                      <button disabled={isLoading||isLoading2} onClick={()=>handleBadgePrint(1)} className="badgeSidebarBtn padding16 w-100 marginBtm32">
                      {isLoading&&<>
                <div className="spinner-border text-primary sm_loader" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
            </>}  Print Badge and return to scanning
                      </button>
                      <button disabled={isLoading||isLoading2} onClick={()=>handleBadgePrint(2)} className="badgeSidebarBtn padding16 w-100 ">
                      {isLoading2&&<>
                <div   className="spinner-border text-primary sm_loader" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
            </>}  Print Badge and Create Another
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
}
          </div>
        </div>
      </section>
    
    </>
  );
};

export default GuestBadge;
